import React, { useState, useRef, useEffect } from "react";
import { RichText, Text } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import { mobileIs } from "../../../utils/siteUtils";
import { Image } from "../../../elements";
import Swiper, { Thumbs, FreeMode } from "swiper";
Swiper.use([Thumbs, FreeMode]);

const ImageSwitch = props => {
  const { items, page } = props;
  const isAR = page?.fields?.rtl?.value;
  const isMobile = mobileIs();
  const [swiperActiveIndex, setSwiperActiveIndex] = useState(0);
  const mainEl = useRef(null);
  const swiperEl = useRef(null);
  const swiper = useRef(null);
  const paginationSwiperEl = useRef(null);
  const paginationSwiper = useRef(null);

  useEffect(() => {
    paginationSwiper.current = new Swiper(paginationSwiperEl.current, {//下面
      enabled: items.length > 1,
      observer: true,
      observeParents: true,
      spaceBetween: 0,
      slidesPerView: 1,
      loop: true,
      rewind: true,
    });
    swiper.current = new Swiper(swiperEl.current, {
      enabled: items.length > 1,
      observer: true,
      observeParents: true,
      loop: true,
      rewind: true,
      on: {
        slideChangeTransitionStart: function(swiper) {
          setSwiperActiveIndex(swiper.realIndex);
          paginationSwiper.current.slideToLoop(swiper.realIndex);
        }
      }
    });


    return () => {
      swiper.current && swiper.current.destroy(true, true);
      paginationSwiper.current && paginationSwiper.current.destroy(true, true);
    };
  }, []);

  const rootClasses = classNames("image-switch");
  const handleTitleClick = (index) => {
    swiper.current.slideToLoop(index);
  }

  return (
    <div className={rootClasses}>
      <div className={"image-switch__main"}  ref={mainEl}>
        <div dir={isAR ? "rtl" : "ltr"} key={isAR ? "rtl" : "ltr"} className="swiper image-switch__swiper" ref={swiperEl}>
          <div className="swiper-wrapper">
            {(items || []).map((item, index) => {
              const itemClasses = classNames("image-switch__item swiper-slide");
              const itemId = `image-switchItemId__${item.id}`;
              const image = isMobile && item?.fields?.m_image?.value ? item.fields.m_image.value : item?.fields?.pc_image?.value;

              return (
                <div id={itemId} className={itemClasses} key={index}>
                  <div className={"image-switch__item-media"}>
                    <Image className="img" { ... image} />                    
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="swiper-controls">
          <div className="q-container">

            <div className="title-navi">
                {/* For desktop */}
                {(items || []).map((item, index) => {
                  const { title } = item.fields;
                  const activeStatus = classNames('navi-title', { active: index === swiperActiveIndex });

                  return (
                    <div className={activeStatus} key={index} index={index} onClick={() => handleTitleClick(index)}>
                      <Text tag="span"  field={title} />
                    </div>
                  );
                })}

            </div>


            <div dir={isAR ? "rtl" : "ltr"} key={isAR ? "rtl" : "ltr"} className="swiper image-switch__pagination-swiper" ref={paginationSwiperEl} >
              <div className="swiper-wrapper">
                {(items || []).map((item, index) => {
                  const { title } = item.fields;
                  const itemClasses = classNames("image-switch__pagination-item swiper-slide",isMobile ? 'mobile' : '');
                  const itemId = `image-switchItemId__pagination-${item.id}`;
                  const { pc_text, m_text } = item.fields;
                  let bodyValue = mobileIs() ? m_text : pc_text;
                  const textsClasses = classNames("image-switch__swiper__text", { active: index === swiperActiveIndex });

                  return (
                    <div id={itemId} className={itemClasses} key={index}>
                      <div className="image-switch__pagination-item__content">
                        <Text tag="h2" className={"image-switch__pagination-item__content__text"} field={title} />

                        <div className={textsClasses} key={index}>
                          <RichText className={"image-switch__item-main__title-body"} field={bodyValue} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};
export default ImageSwitch;
